// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button--hollow.button--primary[data-v-6561b025] {\n  color: var(--magic-text-dark, #231f20);\n}\n.button--hollow.button--secondary[data-v-6561b025] {\n  color: var(--magic-text-dark, #231f20);\n}", ""]);
// Exports
module.exports = exports;
